<template>
<div class="chapter">
<div class="inner_page">
<p class="C587"><strong><span id="page_viii">CONTENTS </span></strong></p>
<p class="C600"><a href="#/html/06_ACKNOWLE#page_x">ACKNOWLEDGMENTS</a></p>
<p class="C600a"><a href="#/html/07_INTRODUC#page_1">INTRODUCTION</a></p>
<p class="C603"><a href="#/html/07_INTRODUC#page_1">The Ethics of the Lie</a></p>
<p class="C600a"><a href="#/html/08_CHAPTER#page_19">CHAPTER 1</a></p>
<p class="C603"><a href="#/html/08_CHAPTER#page_19">The Snare of Truth: <em>Following </em>and the Perfect Patsy</a></p>
<p class="C600a"><span href="#/html/09_CHAPTER#page_39" title="Link target outside of Sample">CHAPTER 2</span></p>
<p class="C603"><em><span href="#/html/09_CHAPTER#page_39" title="Link target outside of Sample">Memento</span></em> <span href="#/html/09_CHAPTER#page_39" title="Link target outside of Sample">and the Desire Not to Know</span></p>
<p class="C600a"><span href="#/html/10_CHAPTER#page_67" title="Link target outside of Sample">CHAPTER 3</span></p>
<p class="C603"><span href="#/html/10_CHAPTER#page_67" title="Link target outside of Sample">The Dirty Cop: <em>Insomnia </em>and the Art of Detection</span></p>
<p class="C600a"><span href="#/html/11_CHAPTER#page_87" title="Link target outside of Sample">CHAPTER 4</span></p>
<p class="C603"><span href="#/html/11_CHAPTER#page_87" title="Link target outside of Sample">The Banal Superhero: The Politicized Realism of <em>Batman Begins </em></span></p>
<p class="C600a"><span href="#/html/12_CHAPTER#page_103" title="Link target outside of Sample">CHAPTER 5</span></p>
<p class="C603"><span href="#/html/12_CHAPTER#page_103" title="Link target outside of Sample">The Violence of Creation in <em>The Prestige </em></span></p>
<p class="C600a"><span href="#/html/13_CHAPTER#page_123" title="Link target outside of Sample">CHAPTER 6</span></p>
<p class="C603"><span href="#/html/13_CHAPTER#page_123" title="Link target outside of Sample">The Hero’s Form of Appearance: The Necessary Darkness of <em>The Dark Knight </em></span></p>
<p class="C600a"><span href="#/html/14_CHAPTER#page_147" title="Link target outside of Sample">CHAPTER 7</span></p>
<p class="C603"><span href="#/html/14_CHAPTER#page_147" title="Link target outside of Sample">A Plea for the Abandonment of Reality in <em>Inception </em></span></p>
<p class="C600a"><span href="#/html/15_CONCLUSI#page_171" title="Link target outside of Sample">CONCLUSION</span></p>
<p class="C603"><span href="#/html/15_CONCLUSI#page_171" title="Link target outside of Sample">Lying without Consequence</span></p>
<p class="C600a"><span href="#/html/16_NOTES#page_179" title="Link target outside of Sample">NOTES</span></p>
<p class="C600a"><span href="#/html/17_BIBLIOGR#page_209" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
<p class="C600a"><span href="#/html/18_INDEX#page_216" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?40d79651